import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private displayTime = 4500;
  private my = 'center center';
  private at = 'center center';

  constructor() {}

  showSuccess(message: string, displayTime?: number, my?: string, at?: string) {
    if (displayTime) {
      this.displayTime = displayTime;
    }
    if (my) {
      this.my = my;
    }
    if (at) {
      this.at = at;
    }
    notify({
      message,
      type: 'success',
      displayTime: this.displayTime,
      position: { my: this.my, at: this.at },
    });
  }

  showInfo(message: string, displayTime?: number, my?: string, at?: string) {
    if (displayTime) {
      this.displayTime = displayTime;
    }
    if (my) {
      this.my = my;
    }
    if (at) {
      this.at = at;
    }
    notify({
      message,
      type: 'info',
      displayTime: this.displayTime,
      position: { my: this.my, at: this.at },
    });
  }

  showWarning(message: string, displayTime?: number, my?: string, at?: string) {
    if (displayTime) {
      this.displayTime = displayTime;
    }
    if (my) {
      this.my = my;
    }
    if (at) {
      this.at = at;
    }
    notify({
      message,
      type: 'warning',
      displayTime: this.displayTime,
      position: { my: this.my, at: this.at },
    });
  }

  showError(message: string, displayTime?: number, my?: string, at?: string) {
    if (displayTime) {
      this.displayTime = displayTime;
    }
    if (my) {
      this.my = my;
    }
    if (at) {
      this.at = at;
    }
    notify({
      message,
      type: 'error',
      displayTime: this.displayTime,
      position: { my: this.my, at: this.at },
    });
  }
}
